<div *ngIf="disableCartIconInHeader==0">
    <div *ngIf="design!=2">
    <button fxFlex *ngIf="(url!='/cart' && url!='/checkout'
    && url!='/checkout/type')"  
    (click)="cart()" mat-button class="flex-row-button">
        <mat-icon  [style.color]="data.headerIconColour"  >shopping_cart</mat-icon>
    
        <span *ngIf="cartServices.cartCount>0" class="cart-items-count">
            {{ cartServices.cartCount }}</span>

          <span style="color: black;" class="padding-10">{{CartName}}</span>  
    </button>
    </div>

    <div *ngIf="design==2">
        <button fxFlex *ngIf="(url!='/cart' && url!='/checkout'
    && url!='/checkout/type')"  
    (click)="cart()" mat-button class="flex-row-button mobcartz">
        <mat-icon class="menu-item-ionx" >shopping_cart</mat-icon>
        <span class="menu-item-cart">Cart</span>
        <span *ngIf="cartServices.cartCount>0" class="cart-items-count badge-view">
            {{ cartServices.cartCount }}</span>

          <span style="color: black;" class="padding-10">{{CartName}}</span>  
    </button>
    </div>
</div>


